export enum UsersDownloadSelectionType {
    All = 'all',
    Filtered = 'filtered',
    Selected = 'selected',
}
